/* eslint-disable @typescript-eslint/no-empty-function */
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFormFieldComponent } from '../base-form-field.component';

@Component({
  selector: 'ellf-date-field',
  template: `
    <ellf-form-field-wrapper
      [label]="label"
      [shouldShowError]="shouldShowError"
      [errors]="errors"
      [tooltip]="tooltip"
    >
      <ellf-datepicker
        [isDatetime]="isDatetime"
        [hasError]="shouldShowError"
        [formControl]="formControl"
        (blur)="onBlur()"
        [readOnly]="readOnly"
        [minDate]="minDate"
        [maxDate]="maxDate"
      >
      </ellf-datepicker>
    </ellf-form-field-wrapper>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateFieldComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DateFieldComponent extends BaseFormFieldComponent {
  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-native
  blur = new EventEmitter();

  @Input()
  isDatetime = false;

  @Input()
  minDate = '';

  @Input()
  maxDate = '';

  onBlur() {
    this.blur.emit();
  }
}
